module.exports = __webpack_public_path__ + "static/media/mobile-box-car.de29486e.svg";